import React from 'react';
import styled, { css } from 'styled-components';
import { borderRadius, compose, fontSize, space, zIndex } from 'styled-system';
import { Text } from '../Text/Text';
import { borderRadiusAttrs } from '../utils/attrs/borderRadiusAttrs';
import { applySizes, applyVariations, borders, getPaletteColor } from '../utils/utils';
const sizes = {
  sm: css(["padding:6px 12px 7px 12px;"]),
  md: css(["padding:10px 12px 11px 12px;"]),
  lg: css(["padding:14px 12px 14px 12px;"]),
  xl: css(["padding:18px 12px 19px 12px;"])
};
const StyledInput = /*#__PURE__*/styled.input.attrs(borderRadiusAttrs).withConfig({
  displayName: "Input__StyledInput",
  componentId: "sc-7wuyrc-0"
})(["position:relative;appearance:none;display:block;width:100%;font-family:inherit;color:", ";background-color:transparent;border-width:1px;border-style:solid;margin:0;::placeholder{color:", ";}::-ms-clear{display:none;}&:disabled{background-color:", ";color:", ";cursor:not-allowed;}", ";", " ", " ", ""], getPaletteColor('text.base'), getPaletteColor('text.light'), getPaletteColor('background.light'), getPaletteColor('text.light'), ({
  theme
}) => applySizes(sizes, undefined, theme.mediaQueries), applyVariations('Input'), borders, props => compose(space, fontSize, borderRadius, zIndex)(props));
const INPUT_ERROR_TEXT = 'InputHelperText';
/**
 * @public
 */
export const Input = React.forwardRef((props, ref) => {
  const {
    helperText,
    color,
    ...restProps
  } = props;
  return React.createElement(React.Fragment, null, React.createElement(StyledInput, {
    ...restProps,
    color: color,
    ref: ref
  }), helperText && React.cloneElement(helperText, {
    color: helperText.props.color || color
  }));
});
const HelperText = /*#__PURE__*/styled(Text).attrs(() => ({
  mt: 2,
  fontSize: 1
})).withConfig({
  displayName: "Input__HelperText",
  componentId: "sc-7wuyrc-1"
})([""]);
Input.HelperText = props => React.createElement(HelperText, {
  ...props
}, props.children);
Input.HelperText.displayName = INPUT_ERROR_TEXT;
Input.displayName = 'Input';
Input.isField = true;
Input.defaultProps = {
  fontSize: [2, null, 1],
  borderRadius: 'lg',
  size: 'lg'
};